// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".special-menu-header[data-v-39f7c6f3]{flex:auto;display:flex;align-items:center;text-decoration:none;padding:0 1rem;width:10rem}@media only screen and (min-width:768px){.special-menu-header[data-v-39f7c6f3]{width:8rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
